var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import { Box, Text } from '@thinkingmachines/asimov';
const CircleLegend = styled.div `
  background: ${props => props.color};
  width: ${props => (props.size = '12px')};
  height: ${props => (props.size = '12px')};
  border-radius: 50%;
  margin-top: auto;
  margin-bottom: auto;
`;
const LegendContainer = styled.div `
  margin-top: auto;
  margin-bottom: autoj
  margin-left: 5px;
  margin-right: 10px;
`;
const TextContainer = styled.div `
  margin: auto 0px;
`;
const TitleSubtitle = ({ title, subtitle }) => (React.createElement(Box, null,
    React.createElement(Text, { fontSize: '14px', fontWeight: 'bold' }, title),
    subtitle ? (React.createElement(Text, { fontSize: '12px', color: 'gray.0' }, subtitle)) : null));
const Label = (_a) => {
    var { label } = _a, props = __rest(_a, ["label"]);
    return (React.createElement(Box, Object.assign({ flexDirection: 'row', padding: '2px' }, props),
        React.createElement(LegendContainer, null, Boolean(label.icon) ? (React.createElement(label.icon, null)) : (React.createElement(CircleLegend, { color: label.color }))),
        React.createElement(TextContainer, null,
            React.createElement(Text, { fontSize: '12px' }, label.text))));
};
/**
 * Simple component for presenting legends. `title`, `subtitle`, and `labels` property can be the defined
 * All other props are passed to the `Panel` container
 */
export const Legend = (_a) => {
    var { title, subtitle, labels } = _a, props = __rest(_a, ["title", "subtitle", "labels"]);
    return (React.createElement(Panel, Object.assign({ width: 'fit-content', px: '10px', py: '10px' }, props),
        React.createElement(TitleSubtitle, { title: title, subtitle: subtitle }),
        labels.map((label, key) => (React.createElement(Label, { key: key, label: label })))));
};
/**
 * A more complex legends that allows division of legends into different categories.
 */
export const MultiLegends = (_a) => {
    var { legends } = _a, props = __rest(_a, ["legends"]);
    return (React.createElement(Panel, Object.assign({ width: 'fit-content', px: '10px', py: '10px' }, props), legends.map((legend, key) => (React.createElement(Box, { key: key },
        React.createElement(TitleSubtitle, { title: legend.title, subtitle: legend.subtitle }),
        legend.labels.map((label, key) => (React.createElement(Label, { key: key, label: label }))))))));
};
//# sourceMappingURL=Legends.js.map